
<section class="w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik cover-outer-container">
  <div class="w-full max-w-1440 mx-5 cover-inner-container flex flex-col 1240-bp:flex-row">
    <!-- Header Section -->
    <header class="w-full flex flex-col">
      <div class="h-full flex flex-col items-start justify-end py-3">
        <h2 class="header-two hidden 1240-bp:inline-block">The largest network of shipping and storage <br> Container Providers in <br> North America.</h2>
        <h2 class="header-two 1240-bp:hidden">The largest network of <br> shipping and storage <br> Container Providers in <br> North America.</h2>
      </div>
    </header>
    <!-- Content Section -->
    <article class="w-full flex flex-col items-start 1240-bp:items-end justify-end">
      <div class="flex flex-col items-start justify-end pb-2">
        <p class="cover-p hidden 1240-bp:inline-block">With providers nationwide, Container Alliance offers an</p>
        <p class="cover-p hidden 1240-bp:inline-block">extensive amount of knowledge to help you find the best</p>
        <p class="cover-p hidden 1240-bp:inline-block">container solution — with prices you won't find anywhere else.</p>
        <p class="cover-p 1240-bp:hidden">With providers nationwide, Container Alliance offers an extensive amount of knowledge to help you find the best container solution — with prices you won't find anywhere else.</p>
      </div>
    </article>
  </div>
</section>
